import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { Invoice } from '../../../models/invoice';
import { CurrencyPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-invoice-view',
    imports: [
        MatButton,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
        CurrencyPipe,
        DatePipe
    ],
    templateUrl: './invoice-view.component.html',
    styleUrl: './invoice-view.component.scss'
})
export class InvoiceViewComponent {

    public invoice: Invoice;

    constructor(@Inject(MAT_DIALOG_DATA) data: { invoice: Invoice },
                private dialogRef: MatDialogRef<InvoiceViewComponent>) {
        this.invoice = data.invoice;
    }

    close(): void {
        this.dialogRef.close();
    }

}
